/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Directive, TemplateRef} from '@angular/core';
export class WizardPageHeaderActionsDirective {
/**
 * @param {?} pageHeaderActionsTemplateRef
 */
constructor(public pageHeaderActionsTemplateRef: TemplateRef<any>) {}
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clrPageHeaderActions]"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
];
}

function WizardPageHeaderActionsDirective_tsickle_Closure_declarations() {
/** @type {?} */
WizardPageHeaderActionsDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WizardPageHeaderActionsDirective.ctorParameters;
/** @type {?} */
WizardPageHeaderActionsDirective.prototype.pageHeaderActionsTemplateRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
